import dotenv from 'dotenv';
import env from 'env-var';

dotenv.config();

export const API_BASE_URL = env.get('REACT_APP_API_BASE_URL').required().asString();
